import { assign, object, optional, pick } from 'superstruct';
import { PaginationQueryDefaulted, SortQuery } from '@arc/shared/util-data';
import { parsableBoolean, searchString } from '@arc/shared/util-superstruct';
export const ARC_ROLES_SORTABLE_FIELDS = ['name', 'createdAt', 'archived'];
export const ListArcRolesQueryDto = assign(PaginationQueryDefaulted(), SortQuery(ARC_ROLES_SORTABLE_FIELDS), object({
  search: searchString(),
  archived: optional(parsableBoolean())
}));
export const ListArcRoleFrontendFilterDto = pick(ListArcRolesQueryDto, ['archived']);
export const defaultArcRolesSort = {
  sort: 'name',
  sortDirection: 'asc'
};